import loadable from '@react-loadable/revised';
import LoadingComponent from 'common/loader';
import type { ApplicationRoute } from 'routes/routes';

const routes: ApplicationRoute[] = [
    {
        path: '/orders',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/list').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/orders/realisations',
        exact: true,
        auth: true,
        component: loadable({
            loader: () =>
                import('modules/orders/pages/realisations/list/index.js').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
    {
        path: '/order/:id/:section?',
        exact: true,
        auth: true,
        component: loadable({
            loader: () => import('./pages/edit/Page').then((m) => m.default),
            loading: LoadingComponent,
        }),
    },
];

export default routes;
